/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 15th 2022, 8:46:00 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { logger } from "lib/logger";

interface UseGetMaxGridItemsToFitOptions {
  estimatedGridItemHeight: number;
  gridColumnCount: number;
}

export const useGetMaxGridItemsToFit = (options: UseGetMaxGridItemsToFitOptions) => {
  const { estimatedGridItemHeight, gridColumnCount } = options;

  const gridContainerRef = React.useRef<HTMLDivElement>();

  const [responsiveItemsToFit, setResponsiveItemFetchLimit] = React.useState<number>();

  React.useEffect(() => {
    const itemsToFit =
      Math.ceil((window.innerHeight - gridContainerRef.current?.offsetTop) / estimatedGridItemHeight) * gridColumnCount;

    logger.debug(
      `responsiveItemsToFit: ${itemsToFit} and gridColumnCount: ${gridColumnCount} and window height - gridOffset ${
        window.innerHeight - gridContainerRef.current?.offsetTop
      }`
    );

    setResponsiveItemFetchLimit(itemsToFit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { responsiveItemsToFit, gridContainerRef };
};
